<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row align="center" justify="center">
      <v-col cols="10">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            Comentarios Alumnos

            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="initialize()"
              small
              class="mr-2"
              :disabled="disabled"
              >Actualizar</v-btn
            >
          </v-card-title>
          <v-card-text>
            <v-row justify="space-between">
              <v-col cols="12" sm="6" lg="4" xl="3">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="cicloInf"
                  :items="ciclos"
                  label="Selecciona ciclo actual"
                  persistent-hint
                  return-object
                  item-text="ciclo"
                  item-value="id_ciclo"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="6" lg="4">
                <v-text-field
                  v-model="search"
                  filled
                  dense
                  label="Buscar"
                  append-icon="mdi-magnify"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="filterAlumnos"
              class="elevation-0"
              :search="search"
              dense
            >
              <template v-slot:item.asistencias="{ item }">
                {{ item.asistencias + " de " + item.total_dias_laborales }}
              </template>

              <template v-slot:item.examenes="{ item }">
                {{ item.examenes + " de " + item.num_examenes }}
              </template>

              <template v-slot:item.ejercicios="{ item }">
                {{ item.ejercicios + " de " + item.num_ejercicios }}
              </template>

              <template v-slot:item.total="{ item }">
                <v-chip small :color="item.total < 70 ? 'red' : 'green'" dark>
                  {{ item.total }}
                </v-chip>
              </template>

              <template v-slot:item.extra="{ item }">
                <v-chip
                  small
                  :color="item.extra < 70 ? 'red' : 'green'"
                  dark
                  v-if="item.extra"
                >
                  {{ item.extra }}
                </v-chip>
              </template>

              <template v-slot:item.ejercicios="{ item }">
                {{ item.ejercicios + " de " + item.num_ejercicios }}
              </template>

              <template v-slot:item.posibilidad="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip small v-bind="attrs" v-on="on">
                      {{
                        parseFloat(item.total) + parseFloat(item.pts_finales)
                      }}
                    </v-chip>
                  </template>
                  <span
                    >Esta es la calificación que el alumno podría obtener si
                    contesta todos sus ejercicios o exámenes faltantes.</span
                  >
                </v-tooltip>
              </template>

              <template v-slot:item.notas="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      @click="
                        (alumnoseleccionado = item),
                          (dialog_mensaje_rechazo = true),
                          getMensajesRechazo()
                      "
                      small
                      class="mr-2"
                      :disabled="disabled"
                      > Enviar Comentario</v-btn
                    >
                  </template>
                </v-tooltip>
              </template>

              <template v-slot:item.id_estado="{ item }">
                <v-chip color="blue" small dark v-if="item.id_estado == 0"
                  >En Revisión</v-chip
                >

                <v-chip color="green" small dark v-if="item.id_estado == 1"
                  >Aceptado</v-chip
                >

                <v-chip color="black" small dark v-if="item.id_estado == 2"
                  >Rechazado</v-chip
                >
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogMensajes" persistent max-width="800">
      <v-card style="position: relative">
        <v-card-title primary-title> Comentarios </v-card-title>

        <v-card-text class="pb-6 pt-6">
          <v-text-field
            v-model="mensaje"
            :append-outer-icon="mensaje ? 'mdi-send' : ''"
            outlined
            clearable
            label="Escribir..."
            type="text"
            @click:append-outer="enviarMensaje()"
            hide-details
            dense
          ></v-text-field>
        </v-card-text>
        <v-btn
          color="transparent elevation-0"
          x-small
          absolute
          top
          right
          fab
          class="mt-5 mr-0"
          @click="(dialogMensajes = false), (mensaje = '')"
          ><v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_mensaje_rechazo" max-width="1000px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1"><b>Enviar Comentario</b></span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" lg="4" xl="3">
              <v-autocomplete
                v-model="comentarioInfo"
                :items="[
                  'El alumno(a) tuvo problemas de salud y eso le afecto en las clases, pero tiene el conocimiento para pasar.',
                  'El alumno(a) entregaba sus actividades y participaba en clase activamente, puede pasar.',
                  'El alumno(a) tiene problemas para asimilar las clases pero sabe lo suficiente para pasar al siguiente nivel.',
                  'El alumno(a) no asistió a las clases por motivos laborales pero se puso al corriente , considero que debe pasar.',
                  'El alumno(a) no asistió a clases por motivos escolares(preparatoria, universidad), pero va al corriente con las clases.'
                ]"
                label="Selecciona un comentario"
                persistent-hint
                return-object
                item-text="ciclo"
                item-value="id_ciclo"
                @change="updateComentario"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row
            style="border: 1px solid gray; padding: 2px; border-radius: 5px"
          >
            <v-col cols="12" :style="{ paddingTop: '10px' }">
              <v-textarea
                v-model="mensaje"
                label="Comentario..."
                outlined
                hide-details
                dense
                auto-grow
                readonly
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="
              (dialog_mensaje_rechazo = false),
                (mensaje = ''),
                (comentarioInfo = null)
            "
          >
            Cancelar
          </v-btn>
          <v-btn
            color="blue darken-1"
            class="elevation-6"
            dark
            @click="enviarMensaje()"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <Loader v-if="cargar" :loader="loader" />
  </v-container>
</template>

<!------------------------------------------------------------------------------------------------->
<!------------------------------------------------------------------------------------------------->
<!------------------------------------------------------------------------------------------------->

<script>
import { mapActions, mapGetters } from "vuex";
// Dependencias
const md5 = require("md5");

// Componentes
import Alerta from "@/components/alertas/Alerta.vue";
import Loader from "@/components/alertas/Loader.vue";

// Mixins
import validarErrores from "@/mixins/validarErrores.js";

export default {
  components: {
    Alerta,
    Loader,
  },

  mixins: [validarErrores],

  data: () => ({
    loader: true,
    cargar: false,
    search: "",
    row: null,

    headers: [
      { text: "Id_Alumno", value: "id_alumno" },
      { text: "Id_Grupo", value: "id_grupo" },
      { text: "Matricula", value: "matricula" },
      { text: "Alumno", value: "nombre" },
      { text: "Grupo", value: "grupo" },
      // { text: 'Asistencias'    , value: 'asistencias' },
      // { text: 'Examenes'       , value: 'examenes'    },
      // { text: 'Actividades'    , value: 'ejercicios'  },
      // { text: 'Total'          , value: 'total'       },
      { text: "Examen Extraordinario", value: "extra" },
      { text: "Pts por obtener", value: "pts_finales" },
      { text: "Posible calif.", value: "posibilidad" },
      { text: "1era", value: "primera" },
      { text: "2da", value: "segunda" },
      { text: "Comentarios", value: "notas" },
      // { text: "Estatus", value: "id_estado" },
    ],
    alumnos: [],
    option: 1,
    alumnoseleccionado: null,

    cicloInf: null,
    ciclos: [],
    ciclo: {},
    idCiclo: 0,
    disabled: true,

    dialogMensajes: false,
    mensajes: [],
    mensaje: "",
    alumno: null,
    dialog_mensaje_rechazo: false,
    comentarioInfo: null,

    dialogSuccess: false,
    overlay: false,
    dialogError: false,
    error: "",
    successMensaje: "",
    errorBack: false,
    textoCopiado: "COPIAR",

    parametros: {
      dialogError: false,
      mensaje: "",
      color: "",
    },

    respuestaAlerta: false,
  }),

  watch: {
    cicloInf() {
      if (this.cicloInf) {
        this.initialize();
        this.disabled = false;
      }
    },
  },

  computed: {
    ...mapGetters("login", [
      "getCalificaciones",
      "getUsuarioLMS",
      "getRecursosGrupoUsuario",
      "getEscuela",
    ]),

    filterAlumnos() {
      
        // Alumnos sin primera oportunidad
        return this.alumnos.filter((el) => {
         return (
            ((el.primera < 70 && el.segunda < 70 && !el.grupo.match("CERTI")) ||
              (el.posibilidad < 80 && !el.grupo.match("CERTI"))) &&
            (el.extra != "" && el.extra < 70) && (el.id_comentario == 0)
          )
        });
    },
  },

  async created() {
    //Despliega los ciclos
    await this.getCiclos();
    console.log(this.getUsuarioLMS.id);
  },

  methods: {
    //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    //TRAE LOS CICLOS                                                  +
    //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    getCiclos() {
      this.overlay = false;
      this.ciclos = [];
      this.planteles = [];

      this.$http
        .get("comentarios.ciclos.all")
        .then((response) => {
          for (const i in response.body) {
            if (!(response.body[i].ciclo.search("FE") != -1)) {
              if (response.body[i].ciclo.search("CICLO") != -1) {
                this.ciclos.push(response.body[i]);
              }
            }
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        });
    },

    initialize() {
      this.cargar = true;
      this.alumnos = [];

      //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
      //TRAE LA INFORMACION PARA LA TABLA                                +
      //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

      this.$http
        .get(
          `comentarios.puntos/${this.cicloInf.id_ciclo}/${this.cicloInf.id_ciclo_relacionado}/${this.getUsuarioLMS.id}/${this.getEscuela}`
        )
        .then((response) => {
          let respuesta = response.body;

          this.calcularCalificaciones(respuesta);
        })
        .catch((error) => {
          this.validarError(error);
        })
        .finally(() => {
          this.cargar = false;
        });
    },

    //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    //Modifica la informacion de la tabla para adaptarla               +
    //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    calcularCalificaciones(value) {
      var arrayCalificaciones = value;

      let alumnos = value.map((item) => {
        return [item.nombre, item];
      });
      var alumnosArray = new Map(alumnos); // Pares de clave y valor

      let unicos = [...alumnosArray.values()]; // Conversión a un array
      for (const i in unicos) {
        var sumaCalifEjercicio = 0;
        var cantEjercicio = 0;
        var sumaCalifExamen = 0;
        var cantExamen = 0;
        var sumaTotal = 0;
        var sumaAsistencia = 0;
        var cantAsistencia = 0;
        var sumaFalta = 0;
        var sumaRetardo = 0;
        var sumaJustificada = 0;
        var califExtra = "";
        for (const j in arrayCalificaciones) {
          if (unicos[i].id_alumno == arrayCalificaciones[j].id_alumno) {
            if (
              arrayCalificaciones[j].tipo_evaluacion == 1 &&
              arrayCalificaciones[j].idCategoriaEvaluacion == 1
            ) {
              sumaCalifEjercicio =
                sumaCalifEjercicio + arrayCalificaciones[j].calificacion;
              cantEjercicio = cantEjercicio + 1;
            } else {
              if (
                (arrayCalificaciones[j].tipo_evaluacion == 2 &&
                  arrayCalificaciones[j].idCategoriaEvaluacion == 1) ||
                (arrayCalificaciones[j].tipo_evaluacion == 2 &&
                  arrayCalificaciones[j].idCategoriaEvaluacion == 2)
              ) {
                sumaCalifExamen =
                  sumaCalifExamen + arrayCalificaciones[j].calificacion;
                cantExamen = cantExamen + 1;
              } else {
                califExtra = arrayCalificaciones[j].calificacion;
              }
            }
          }
        }

        // Haciendo el calculo para los puntos obtenidos de asistencias
        sumaAsistencia = unicos[i].asistencia;
        sumaFalta = unicos[i].falta;
        sumaRetardo = unicos[i].retardo;
        sumaJustificada = unicos[i].justificada;

        var ptsAsistencia =
          unicos[i].valor_asistencia / unicos[i].total_dias_laborales;
        var sumaTotalAsistencia =
          unicos[i].asistencia * ptsAsistencia +
          unicos[i].retardo * (ptsAsistencia / 2);

        // Calulando los puntos por ejercicios
        var divEjercico = sumaCalifEjercicio / unicos[i].num_ejercicios;
        var ptsEjercicio = unicos[i].valor_ejercicios / 100;
        var ptsFinalesEjercicios = divEjercico * ptsEjercicio;

        var divExamenes = sumaCalifExamen / unicos[i].num_examenes;
        var ptsExamenes = unicos[i].valor_examenes / 100;
        var ptsFinalesExamenes = divExamenes * ptsExamenes;

        cantAsistencia = sumaAsistencia + sumaRetardo;

        // Puntos de los ejercicios
        var ejerciciosFaltante = unicos[i].num_ejercicios - cantEjercicio;
        var ptsDispoEjercicio =
          ejerciciosFaltante *
          (unicos[i].valor_ejercicios / unicos[i].num_ejercicios);

        // Pts de los examenes
        var examenesFaltante = unicos[i].num_examenes - cantExamen;
        var ptsDispoExamen =
          examenesFaltante *
          (unicos[i].valor_examenes / unicos[i].num_examenes);

        // Puntos de las asistencias
        var asistenciasFaltante =
          unicos[i].total_dias_laborales - cantAsistencia;
        var ptsDispoAsis =
          asistenciasFaltante *
          (unicos[i].valor_asistencia / unicos[i].total_dias_laborales);

        // Puntos finales
        var ptsDispoFinales = ptsDispoEjercicio + ptsDispoExamen + ptsDispoAsis;

        var payload = {
          nombre: unicos[i].nombre,
          matricula: unicos[i].matricula,
          grupo: unicos[i].grupo,
          examenes: cantExamen,
          num_examenes: unicos[i].num_examenes,
          ejercicios: cantEjercicio,
          num_ejercicios: unicos[i].num_ejercicios,
          total: (
            ptsFinalesEjercicios +
            ptsFinalesExamenes +
            sumaTotalAsistencia
          ).toFixed(2),
          asistencias: cantAsistencia,
          total_dias_laborales: unicos[i].total_dias_laborales,
          pts_finales: ptsDispoFinales.toFixed(2),
          telefono: unicos[i].telefono,
          celular: unicos[i].celular,
          extra: califExtra,
          ptsDispoEjercicio: ptsFinalesEjercicios,
          ptsDispoExamen: ptsFinalesExamenes,
          ptsDispoAsis: sumaTotalAsistencia,
          teacher: "",
          teacher2: "",
          primera: unicos[i].calificacion_final_primera_oportunidad,
          segunda: unicos[i].calificacion_final_segunda_oportunidad,
          id_curso: unicos[i].id_curso,
          id_grupo: unicos[i].id_grupo,
          id_nivel: unicos[i].id_nivel,
          id_alumno: unicos[i].id_alumno,
         // id_estado: unicos[i].estado, estatus Rdz
          id_comentario: unicos[i].id_comentario  // Angel Rdz, 1 o 0, dependiendo de si ya paso con comentario o no
        }; 

        this.alumnos.push(payload);
  
      }
      this.cargar = false;
    },

    //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // Enviar el comentario a LUIS                                     +
    //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    enviarMensaje() {
      this.overlay = true;
      // let payload = {
      //   id_usuario:         this.getdatosUsuario.iderp,
      //   id_grupo:           this.alumno.id_grupo,
      //   id_alumno:          this.alumno.id_alumno,
      //   id_unidad_negocio:  this.alumno.id_unidad_negocio,
      //   nota:               this.mensaje,
      //   tipo_usuario:       1
      // }

      let payload = {
        id_usuario: this.getUsuarioLMS.id,
        id_alumno: this.alumnoseleccionado.id_alumno,
        mensaje: this.mensaje,
        id_grupo: this.alumnoseleccionado.id_grupo,
      };

      this.$http
        .post("comentarios.reprobados.comentarios.add", payload)
        .then((response) => {
          this.mensaje = "";
          this.mensajes = [];
          this.overlay = false;
          this.dialogMensajes = false;
          this.dialog_mensaje_rechazo = false;
          this.comentarioInfo = null;
          this.initialize();
        })
        .catch((error) => {
          this.error = error.body.message;
          this.dialogError = true;
          this.overlay = false;
          this.dialogRechazar = false;
        });
    },

    updateComentario() {
      this.mensaje = this.comentarioInfo || "";
    },
  },
};
</script>

<style>
.v-snack__content {
  padding: 0px !important;
}
</style>